import * as React from 'react'
import { styleguide } from 'styleguide'

export default props => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 147 114"
    version="1.1"
    {...props}>
    <defs>
      <circle id="survey-path-1" cx="108.5" cy="80.5" r="38.5" />
      <pattern
        id="survey-pattern-2"
        width="36.841299"
        height="36.841299"
        x="33.158701"
        y="5.15870098"
        patternUnits="userSpaceOnUse">
        <use
          xlinkHref="#survey-image-3"
          transform="scale(0.36841299,0.36841299)"
        />
      </pattern>
      <image
        id="survey-image-3"
        width="100"
        height="100"
        xlinkHref="data:image/png;base64,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"
      />
      <circle id="survey-path-4" cx="25" cy="54" r="25" />
      <pattern
        id="survey-pattern-5"
        width="36.841299"
        height="36.841299"
        x="-36.841299"
        y="-7.84129902"
        patternUnits="userSpaceOnUse">
        <use
          xlinkHref="#survey-image-6"
          transform="scale(0.36841299,0.36841299)"
        />
      </pattern>
      <image
        id="survey-image-6"
        width="100"
        height="100"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
    <g
      id="survey-Desktop-Copy-3"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g id="survey-Group-38" transform="translate(-49.000000, -5.000000)">
        <g id="survey-Group-34" transform="translate(49.000000, 0.000000)">
          <g id="survey-Oval-7">
            <use
              fill={styleguide.colors.illustrationLightBlue}
              xlinkHref="#survey-path-1"
            />
            <use fill="url(#survey-pattern-2)" xlinkHref="#survey-path-1" />
          </g>
          <g id="survey-Oval-7">
            <use
              fill={styleguide.colors.illustrationLightBlue}
              xlinkHref="#survey-path-4"
            />
            <use fill="url(#survey-pattern-5)" xlinkHref="#survey-path-4" />
          </g>
          <g
            id="survey-Group-23"
            transform="translate(11.000000, 0.000000)"
            stroke={styleguide.colors.illustrationStroke}>
            <g
              id="survey-Group-24-Copy"
              transform="translate(92.460324, 64.213510) rotate(226.000000) translate(-92.460324, -64.213510) translate(51.960324, 13.713510)"
              stroke-width="1.25">
              <path
                d="M73.853194,68.9716716 C73.853194,43.3956129 53.3329235,22.6621207 28.019887,22.6621207 C12.897372,22.6621207 -0.514553643,30.0621257 -8.86238328,41.4737838"
                id="survey-Oval-6"
                transform="translate(32.495405, 45.816896) rotate(-76.000000) translate(-32.495405, -45.816896) "
              />
              <path
                d="M72.8684848,107.398746 C72.8684848,99.9719796 71.0975885,92.9483762 67.9449385,86.7072443"
                id="survey-Oval-6"
                transform="translate(70.406712, 97.052995) rotate(82.000000) translate(-70.406712, -97.052995) "
              />
              <path
                d="M27.4594814,97.2989093 C27.4594814,93.9187021 27.0056451,90.6223259 26.1435336,87.4458133"
                id="survey-Oval-6"
                transform="translate(26.801508, 92.372361) rotate(131.000000) translate(-26.801508, -92.372361) "
              />
            </g>
            <g
              id="survey-Group-24"
              transform="translate(34.491061, 38.158273) rotate(35.000000) translate(-34.491061, -38.158273) translate(11.991061, 10.158273)">
              <path
                d="M40.6947596,37.9817756 C40.6947596,23.8973827 29.3876321,12.4797263 15.4395836,12.4797263 C7.10674004,12.4797263 -0.283530551,16.5548099 -4.88337115,22.8390571"
                id="survey-Oval-6"
                transform="translate(17.905694, 25.230751) rotate(-76.000000) translate(-17.905694, -25.230751) "
              />
              <path
                d="M40.1521628,59.1430506 C40.1521628,55.0532299 39.1763594,51.1854256 37.4391788,47.7485179"
                id="survey-Oval-6"
                transform="translate(38.795671, 53.445784) rotate(82.000000) translate(-38.795671, -53.445784) "
              />
              <path
                d="M14.9031761,53.6849344 C14.9031761,51.8234996 14.6531022,50.0082294 14.1780595,48.2589665"
                id="survey-Oval-6"
                transform="translate(14.678059, 50.971950) rotate(131.000000) translate(-14.678059, -50.971950) "
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/Sections/HowItWorks/Background/SurveySvg.jsx